<template>
<transition
appear
@enter="enter"
>
  <div class="c-gnav">
    <header id="c-header" class="c-header">
      <a class="c-header__logo" href="https://www.pearlygates.net/">
        <img src="assets/img/common/logo@2x.png" alt="PEARLY GATES" width="159" height="20" />
      </a>
      <h2 class="c-header__title">Web Catalog</h2>
    </header>
    <div v-if="siteData" class="c-band">
      <div class="c-band__bg" :style="{'background-color': `#${siteData.keycolor}`}"></div>
      <h1 class="c-band__title">
        <span>{{siteData.sitename}}</span>
      </h1>
    </div>
  </div>
</transition>
</template>

<script>
import {gsap, Power2, Power3, Expo} from 'gsap/all';

export default {
  data() {
    return {
      siteData: null,
    }
  },
  computed: {
  },
  mounted() {
    this.siteData = this.$store.getters.siteData;
  },
  methods: {
    enter(el, done) {
      gsap.fromTo(el, {
        opacity: 0,
      }, {
        duration: 1.2,
        opacity: 1,
        ease: Power2.easeInOut,
      });

      done();
    },
  }
}
</script>